
import { OnChanges, Input, Component, OnInit } from '@angular/core';
import { FormField, RadioGroupInterface, RadioFieldInterface, Alignment } from '../models/form-field';
import { FormGroup } from '@angular/forms';
import { DynamicFormFieldComponent } from './dynamic-form-field.component';
import { Util } from '../utils/utils.module';

@Component({
  selector: 'edx-radio-field',
  styleUrls: ['dynamic-form-field.component.scss'],
  template: `
    <div [formGroup]="form" class="controlcontainer columnview fullwidth" [title]="ariaLabel">
      <div class="checkboxlabel" [ngClass]="{readonly:viewReadonly || field.isDisabled, indialog:inDialog}">
        <input [formControlName]="field.name" value="{{value}}" type="{{field.isRGCheckboxes?'checkbox':'radio'}}" [ngClass]="{checkbox:field.isRGCheckboxes, radio:!field.isRGCheckboxes, checked:isChecked}" tabindex="-1">
        <span class="checkboxlabel" [ngClass]="{disablecheckedradio:(isChecked && ((field.isDisabled && !field.isRGCheckboxes) || parent?.previewOnly)), disableuncheckedradio:(!isChecked && ((field.isDisabled && !field.isRGCheckboxes) || parent?.previewOnly))}" [id]="radioId" [tabindex]="viewReadonly || field.isDisabled?-1:tabIndex" [attr.role]="field.isRGCheckboxes?'checkbox':'radio'" [attr.aria-label]="isChrome?(isChecked?ariaLabel:ariaLabel+' '):null" [attr.aria-checked]="isChecked" [attr.aria-disabled]="viewReadonly || field.isDisabled" (click)="!field.isDisabled ? rbClicked($event) : $event.preventDefault()" (keydown.space)="!field.isDisabled ? rbClicked($event) : $event.preventDefault()" (keyup)="onKeyUp($event, itemIndex)">{{label}}</span>
      </div>
    </div>
  `,
  standalone: false
})
export class RadioFieldComponent implements OnInit, OnChanges, RadioFieldInterface {
  @Input() field: FormField;
  @Input() form: FormGroup;
  @Input() value: string;
  @Input() label: string;
  @Input() radioGroup: RadioGroupInterface;
  @Input() parent?: DynamicFormFieldComponent;
  @Input() inDialog?: boolean = false;
  @Input() formReadonly?: boolean = false;
  @Input() columnView?: boolean = false;
  @Input() itemIndex: number;
  @Input() radioId: string;
  @Input() tabIndex = 0;
  @Input() rerender = 0;
  public isChecked = false;
  public viewReadonly = false;
  public isChrome = false;
  public ariaLabel: string;

  constructor() { }

  ngOnInit(): void {
    this.setAriaLabelForRadioButton();
  }

  ngOnChanges() {
    let value: string = this.form.controls[this.field.name].value;
    value = value ? value.toString() : null;
    this.isChecked = (this.value === value) || (this.value === 'null' && value === null);
    this.viewReadonly = this.field.isReadonly || this.formReadonly || this.isRadioButtonDisabled() || this.parent?.previewOnly;
    this.isChrome = Util.Device.bIsChrome;
  }

  private setAriaLabelForRadioButton(): void {
    if (!this.label && this.isHorizontalAligned()) {
      const displayValue = this.field.buttonMap.find(x => x.value === this.value)?.display;
      this.ariaLabel = this.field.checkLabel + ' ' + displayValue;
    } else {
      this.ariaLabel = this.label;
    }
  }

  private isHorizontalAligned(): boolean {
    return !!this.field.alignment && this.field.alignment === Alignment.HORIZONTAL;
  }

  public rbClicked(event: Event): boolean {
    if (!!event && event.type === 'keydown') {
      event.preventDefault();
    }
    if (this.parent && !this.viewReadonly && !this.isChecked) {
      this.isChecked = true;
      this.radioGroup.radioButtonOn(this, this.value);
    }
    return true;
  }

  public onKeyUp(event: KeyboardEvent, itemIndex: number) {
    let shiftFocus = false;
    if (this.isHorizontalAligned()) {
      switch (event.key) {
        case 'ArrowLeft':
          itemIndex = itemIndex - 1;
          shiftFocus = true;
          break;
        case 'ArrowRight':
          itemIndex = itemIndex + 1;
          shiftFocus = true;
          break;
      }
    } else {
      switch (event.key) {
        case 'ArrowUp':
          itemIndex = itemIndex - 1;
          shiftFocus = true;
          break;
        case 'ArrowDown':
          itemIndex = itemIndex + 1;
          shiftFocus = true;
          break;
      }
    }
    if (shiftFocus) {
      this.radioGroup.shiftRadioFocus(event, itemIndex);
    }
  }

  public isRadioButtonDisabled(): boolean {
    return ((this.field.name === 'ALLOW_DOC_CREATE' || this.field.name === 'VIEW_UNSECURED') && this.value === 'D');
  }
}
